import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import * as Modules from 'components/modules';
import * as selectors from 'selectors';
import { removeAnimationContainer } from 'helpers';
import * as actions from 'actions';
import styles from './home.css';

class Home extends React.Component {
  state = {
    loadedTiles: 0,
  };

  componentDidMount() {
    this.mainWrapper.focus();
  }

  componentDidUpdate() {
    const pageReadyCheck = this.props.tiles.length === this.state.loadedTiles;
    if (pageReadyCheck) {
      this.props.setPageReady();
    }
  }

  handleTileLoad = () => {
    this.setState(prevState => ({ loadedTiles: prevState.loadedTiles + 1 }));
  };

  render() {
    const {
      tiles, tilesLoadCompleteProp, direction, meta,
    } = this.props;
    return (
      <React.Fragment>
        <Modules.Meta {...meta} />
        <TransitionGroup>
          <CSSTransition
            classNames={{
              enter: styles.tilesEnter,
              enterActive: styles.tilesEnterActive,
              exit: styles.tilesExit,
              exitActive: styles.tilesExitActive,
            }}
            key="tiles"
            in={tilesLoadCompleteProp}
            timeout={0}
          >
            <div
              className={styles.mainWrapper}
              tabIndex={0}
              ref={(mainWrapper) => {
                this.mainWrapper = mainWrapper;
              }}
            >
              <main className={styles.tiles}>
                {tiles &&
                  tiles.map(entry => (
                    <Modules.CaseTile
                      key={entry.href}
                      to={entry.href}
                      {...entry}
                      back={direction !== 'homeInitial'}
                      loadCb={this.handleTileLoad}
                    />
                  ))}
              </main>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  direction: state.direction,
  meta: selectors.getStaticMeta(state),
  tiles: selectors.getTiles(state),
  tilesLoadCompleteProp: state.pageReady,
});

const mapDispatchToProps = dispatch => ({
  setPageReady: () => dispatch(actions.setPageReady()),
});

Home.defaultProps = {
  tiles: [],
  direction: null,
};

Home.propTypes = {
  tiles: T.array,
  tilesLoadCompleteProp: T.bool.isRequired,
  direction: T.string,
  setPageReady: T.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/screens/Home/Home.js